export default "__VITE_ASSET__76251b5b__"